import { apiClient } from './request';

export async function getProducts() {
  try {
    const data = await apiClient.get(`/products`);
    return data;
  } catch (error) {
    console.error('获取产品信息失败:', error);
    throw error; // 重新抛出以便上层处理
  }
}

export async function getProductDetails(productID) {
  try {
    // uin/skey 通过 Cookie 由浏览器自动携带，后端从 Cookie 读取，禁止再拼到 URL 上
    const url = `/product-details?ProductID=${productID}`;
    const data = await apiClient.get(url);
    return data;
  } catch (error) {
    console.error('获取产品详情:', error);
    throw error; // 重新抛出以便上层处理
  }
}

export async function auditLog(
  message,
  action,
  resource,
  metadata?: Record<string, string>
) {
  try {
    // 用户身份由 Cookie 自动携带，请求体不再传 UIN / SKey，避免凭证泄露和越权
    const reqData = {
      Message: metadata ? JSON.stringify(metadata) : message,
      Action: action,
      Resource: resource
    };
    const url = `/audit-log`;
    await apiClient.post(url, reqData);
  } catch (error) {
    console.error('审计日志:', error);
  }
}
